import { createTheme } from '@mui/material/styles';
import { sharedColors } from './shared.styles';

export const customTheme = createTheme({
  palette: {
    background: { default: sharedColors.bgMain },
  },
});
